import api from '@/api'
import {
  isWeChat
} from '@/utils/tool'
import wx from 'weixin-js-sdk'
const shareConfig = {
  title: `${brandConfig.companyName}管理平台`,
  desc: '一个有温度的健康管理服务平台。提供全国公立医院及体检机构的个人/团体体检预约，在线健康咨询、体检报告查询；体检报告解读；及其他企业健康福利预约服务。',
  imgUrl: brandConfig.shareImg,
  link: document.URL,
  success: function () {}
}

function addChannel(payload) {
  const channel = sessionStorage.getItem('channel')
  if (!channel || payload.link.indexOf('channel') !== -1) {
    return payload
  }
  payload.link = `${payload.link}${payload.link.indexOf('?') !== -1 ? '&' : '?'}channel=${channel}`
  return payload
}

function wechatSDK(payload = {}) {
  // payload = Object.assign({}, shareConfig, { link: document.URL }, payload)
  let params = {
    title: payload.title || shareConfig.title,
    desc: payload.desc || shareConfig.desc,
    imgUrl: payload.imgUrl || shareConfig.imgUrl,
    link: payload.link || shareConfig.link,
    success: payload.success || shareConfig.success,
    implementRequest: true
  }
  // 访问渠道为非微信浏览器不调用微信sdk
  if (!isWeChat()) {
    return
  }

  // 微信分享前带上channel
  params = addChannel(params)

  // 带hasSign参数时，不执行请求，直接设置分享参数
  if (payload.hasSign) {
    delete payload.hasSign
    // wechatShare(wx, payload)
    wx.ready(function () {
      // 访问渠道为小程序webview时，不调用微信分享
      // if (!window.IS_WEBVIEW) {
      if (payload.hiddenWeChatShare) {
        // 隐藏微信分享
        wechatHideMenuItems()
      } else {
        wechatShare(wx, params)
      }
      // }
    })
    wx.error(function (res) {
      // console.log(res)
    })
    return
  }
  api.common.wechatConfig().then((res) => {
    // console.log('wechat', res)

    const jsApiList = ['updateAppMessageShareData', 'updateTimelineShareData', 'scanQRCode']
    if (payload.hiddenWeChatShare) {
      jsApiList.push('hideMenuItems')
    }
    const openTagList = ['wx-open-launch-weapp'] // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']

    const {
      appId,
      timestamp,
      signature,
      nonceStr
    } = res.data
    wx.config({
      debug: false,
      appId,
      timestamp,
      nonceStr,
      signature,
      jsApiList,
      openTagList
    })
    wx.ready(function () {
      // 访问渠道为小程序webview时，不调用微信分享
      // if (!window.IS_WEBVIEW) {
      if (payload.hiddenWeChatShare) {
        // 隐藏微信分享
        wechatHideMenuItems()
      } else {
        wechatShare(wx, params)
      }
      // }
    })
    wx.error(function (res) {
      // console.log('err', res)
    })
  })
}

function wechatShare(wx, payload) {
  console.log('初始化微信分享执行wechatShare')
  wx.updateTimelineShareData(payload)
  wx.updateAppMessageShareData(payload)
}

function wechatHideMenuItems() {
  wx.hideMenuItems({
    // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
    menuList: ['menuItem:share:appMessage', 'menuItem:share:timeline', 'menuItem:share:qq', 'menuItem:share:weiboApp', 'menuItem:share:QZone']
  })
}

export default wechatSDK

export function scanCode(callback) {
  console.log(111)

  wx.scanQRCode({

    needResult: 1,

    scanType: ['qrCode', 'barCode', 'datamatrix'],

    success: function (res) {
      callback('success', res)

      // console.log(res)

      // alert(JSON.stringify(res));

      // var result = res.resultStr;

      // setTimeout(callback(result), 500);
    },

    error: function (res) {
      callback('error', res)

      // alert(JSON.stringify(res))

      // if (res.errMsg.indexOf('function_not_exist') > 0) {

      //   ('版本过低请升级')

      // }
    }

  })
}
